import { useEventListener } from '@iwbam/react-ez';
import { Auth } from 'aws-amplify';
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { User } from '../../utils/interfaces';

const ForgetPassword = ({ user }: { user: undefined | null | User }) => {

  const navigate = useNavigate();
  const submitRef = useRef(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [isValidInfo, setIsValidInfo] = useState(false);

  const [errorMessage, setErrorMessage] = useState('');
  
  // check if user logged in
  useEffect(() => {
    if (user) navigate('/');
  }, [user]);

  // check if information is valid
  useEffect(() => setIsValidInfo(email.length > 0 && password.length > 0), [email, password]);

  // event listener
  useEventListener('keydown', (e) => {
    if (e.key === 'Enter' && submitRef.current) {
      (submitRef.current as HTMLElement).click();
    }
  });

  // send verification code
  const sendCode = async () => {
    setErrorMessage('');
    try {
      await Auth.forgotPassword(email);
    } catch (error: any) {
      if (error.name === 'InvalidPasswordException') {
        setErrorMessage('The password has to be at least 8 characters');
      }
    }
  }

  // confirm sign up and create user
  const submit = async () => {
    setErrorMessage('');
    try {
      await Auth.forgotPasswordSubmit(email, code, password);
      navigate('/login');
    } catch (error) {
      setErrorMessage('Incorrect verification code');
    }
  }

  return (
    <main className='flex flex-col items-center justify-center flex-1 scroller'>
      <div className='scroller w-full h-full flex flex-col items-center'>
        <div className='flex flex-col items-center w-5/6 max-w-sm *:w-full h-full my-20'>
          <div className='text-3xl font-bold'>Forget password</div>
          <div className='mt-8' />
          {errorMessage.length > 0 && <div className='text-red-400 my-2 text-xs text-center'>{errorMessage}</div>}
          <label className='text-sm'>Email</label>
          <input className='bg-gray-700 mt-1 p-2 rounded' value={email} onInput={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)} />
          <div className='mt-4' />
          <label className='text-sm'>New Password</label>
          <input type='password' className='bg-gray-700 mt-1 p-2 rounded' value={password} onInput={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)} />
          <div className='mt-4' />
          <label className='text-sm'>Email verification</label>
          <div className='flex mt-1'>
            <input className='flex-1 bg-gray-700 p-2 rounded' value={code} onInput={(e: React.ChangeEvent<HTMLInputElement>) => setCode(e.target.value)} />
            <button onClick={sendCode} className='trans-2 text-sm rounded bg-emerald-500 font-bold px-4 ml-4 disabled:bg-gray-400 active:bg-emerald-600' disabled={!isValidInfo}>Send code</button>
          </div>
          <button ref={submitRef} onClick={submit} className='trans-2 bg-emerald-500 rounded py-2 font-bold mt-8 disabled:bg-gray-400 active:bg-emerald-600' disabled={!isValidInfo || code.length === 0}>Reset password</button>
        </div>
      </div>
    </main>
  )
}

export default ForgetPassword